import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS } from '../../../constants'

export const styles = makeStyles(theme => ({
  topSection: {
    width: '89%',
    margin: '0 auto',
    overflow: 'visible',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      minHeight: '582px',
    },
    [`@media (min-width: ${BREAKPOINTS.lg + 1}px)`]: {
      minHeight: '582px',
    },
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      width: '90%',
    },
  },
  topSectionLinks: {
    display: 'flex',
    justifyContent: 'space-between',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      marginTop: '20px',
    },
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      marginTop: '38px',
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      marginTop: '20px',
    },
  },
  accordionLink: {
    color: COLORS.black,
  },
  circle: {
    width: 252,
    height: 252,
    backgroundColor: '#175972',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    cursor: 'pointer',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      display: 'none',
    },
  },
  circleText: {
    fontSize: '1.875rem !important',
    color: theme.palette.common.white,
    marginBottom: '5px !important',
  },
  circleInfo: {
    padding: 30,
    textAlign: 'center',
  },
  categoriesMargin: {
    paddingTop: 55,
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      [`& .MuiGrid-spacing-xs-3`]: {
        width: 'calc(100% + 51px)',
        margin: '-26px',
      },
      [`& .MuiGrid-spacing-xs-3 > .MuiGrid-item`]: {
        padding: 0,
      },
    },
  },
  rowLink: {
    color: theme.palette.common.black,
    opacity: '0.8',
    textDecoration: 'none',
    cursor: 'pointer',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      width: '50%',
      marginTop: '20px',
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      width: '15%',
      marginTop: 0,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      width: '25%',
      textAlign: 'center',
    },
  },
  rowLinkText: {
    display: 'inline-block',
    fontFamily: 'Schnyder M Light',
    lineHeight: '86px',
    letterSpacing: '-0.01562em',
    marginBottom: 0,
    borderBottom: '1px solid',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      fontSize: '2.5rem',
    },
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      fontSize: '3rem',
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      fontSize: '2.25rem',
      lineHeight: '40px',
    },
    [`@media (max-width: ${BREAKPOINTS.xmd}px)`]: {
      lineHeight: '40px',
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      fontSize: '30px',
    },
  },
  blogItemContainer: {
    width: '100%',
    // maxWidth: 706,
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      maxWidth: '100%',
    },
  },
  rowText: {
    display: 'inline-block',
    fontFamily: 'Schnyder M Light',
    lineHeight: '86px',
    letterSpacing: '-0.01562em',
    marginBottom: 0,
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      fontSize: '2.5rem',
    },
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      fontSize: '3rem',
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      fontSize: '2.25rem',
      lineHeight: '40px',
    },
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      // fontSize: '2.25rem',
      // lineHeight: '40px',
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      textAlign: 'center',
      fontSize: '30px',
      width: '100%',
      paddingTop: 25,
      paddingBottom: 20,
    },
  },
  blogLinks: {
    flexWrap: 'wrap',
    [`@media (min-width: ${BREAKPOINTS.lg + 1}px)`]: {
      paddingTop: 60,
    },
  },
  hideCircle: {
    display: 'none',
  },
  customLinks: {
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      ['& > div:not(:last-child)']: { marginBottom: '20px' },
    },
  },
  addExt: {
    display: 'inline',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}))
